import React from "react";
import { useHistory } from "react-router-dom";
import CustomIcons from "../../../../../components/icons/kIcons.component";
import jwtDecode from "jwt-decode";

export default function DashApplicationDetails(props) {
  let tokenData = props?.state?.payload ? jwtDecode(props.state.payload) : {};
  const capitalizeFirst = (text) => {
    if (!text) return "";
    const str = text.toString();
    return str.charAt(0).toUpperCase() + str.slice(1);
  };
  const history = useHistory();
  console.log("DashApplicationDetails Props:", {
    data: props?.data,
    userType: props?.userType,
    appData: props?.appData,
    isCompanyUser: props?.data?.is_company_user
  });
  const handleMenuDash = () => {
    let menuSwitch = props.state.dashMenu === true ? "SWITCHMENUFALSE" : "SWITCHMENUTRUE";
    props.setlang(menuSwitch);
  }

  const getStatusLabel = () => {
    const isCompany = props?.data?.is_company_user || [0, 4, 5, 6].includes(Number(props.userType));

    if (isCompany) {
      // For company users, check company status
      if (props?.data?.is_company_user) {
        const s = props?.data?.parent_company?.status !== undefined ? props?.data?.parent_company?.status :
          props?.applications?.application_status !== undefined ? props?.applications?.application_status :
            props?.data?.applicants?.application_status !== undefined ? props?.data?.applicants?.application_status :
              props?.appData?.application_status;

        if (s !== undefined && s !== null) {
          return s === 0 ? "Pending" :
            s === 1 ? "Submitted" :
              s === 2 ? "Accepted" :
                s === 3 ? "In Progress" :
                  s === 5 ? "Reverted" :
                    s === 4 ? "Rejected" :
                      s === 6 ? "Agreement Execution" :
                        s === 7 ? "Ongoing Project" :
                          s === 8 ? "Completed" :
                            s === 16 ? "Waiting for final approval" :
                              s === 15 ? "Suggestion" : "";
        }
      }

      // Fallback for regular company applications
      const s = props?.appData?.application_status;
      if (s !== undefined && s !== null) {
        return s === 0 ? "Pending" :
          s === 1 ? "Submitted" :
            s === 2 ? "Accepted" :
              s === 3 ? "In Progress" :
                s === 5 ? "Reverted" :
                  s === 4 ? "Rejected" :
                    s === 6 ? "Agreement Execution" :
                      s === 7 ? "Ongoing Project" :
                        s === 8 ? "Completed" :
                          s === 16 ? "Waiting for final approval" :
                            s === 15 ? "Suggestion" : "";
      }
    }

    if ([9, 8, 10].includes(Number(props.userType))) {
      const s = props?.appData?.approval_status;
      if (s !== undefined && s !== null) {
        return s === 0 ? "Pending" :
          s === 1 ? "Submitted" :
            s === 2 ? "Accepted" :
              s === 3 ? "In Progress" :
                s === 5 ? "Reverted" :
                  s === 4 ? "Rejected" :
                    s === 15 ? "Suggestion" : "";
      }
    }

    if (Number(props.userType) === 20) {
      const s = props?.appData?.status;
      if (s !== undefined && s !== null) {
        return s === 0 ? "Pending" :
          s === 1 ? "Submitted" :
            s === 2 ? "Accepted" :
              s === 3 ? "Reverted" :
                s === 5 ? "Rejected" :
                  s === 4 ? "Submitted" :
                    s === 9 ? "Deactivated" : "";
      }
    }

    if ([6, 5].includes(Number(props.userType))) {
      const s = props?.appData?.project_status;
      if (s !== undefined && s !== null) {
        return s === 0 ? "Pending" :
          s === 1 ? "In Progress" :
            s === 2 ? "Accepted" :
              s === 3 ? "In Progress" :
                s === 5 ? "Reverted" :
                  s === 4 ? "Rejected" : "";
      }
    }
    return "";
  };

  const applicationId = (props?.data?.is_company_user || [0, 4, 5, 6, 8].includes(Number(props.userType)))
    ? props?.data?.parent_company?.unique_application_ref_no ||
    props?.applications?.unique_application_ref_no ||
    props?.appData?.unique_application_ref_no ||
    props?.data?.applicants?.unique_application_ref_no ||
    props?.data?.unique_application_ref_no
    : null;

  const showMyApplicationBtn = (
    (props?.userType === 0 && props?.userType !== 20 && props?.userType !== 21 && props?.appData?.application_status !== 4) ||
    (props.userType !== 0 && props.userType !== 7 && props?.userType !== 20 && props?.userType !== 21 && (props.appData?.approval_status !== 3 || props.appData?.project_status !== 3))
  );
  return (
    <React.Fragment>
      <div>
        <div className="row muli">
          <div className="col-12 col-md-6 dash-content-detail-items">
            <div className="userDashb h-100" style={{ padding: 12 }}>
              <div style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                gap: 12,
                border: "1px solid #e9ecef",
                borderRadius: 8,
                padding: 12,
                background: "#fff"
              }}>
                <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
                  <div className="u-logo" style={{ width: 82, height: 82 }}>
                    <div className="user-name-logo" style={{ width: "100%", height: "100%" }}>
                      {props?.appData?.logo ? (
                        <img
                          alt="logo"
                          src={
                            /^(https?:)?\/\//.test(props?.appData?.logo)
                              ? props?.appData?.logo
                              : props?.url
                                ? `${props.url}/${props?.appData?.logo}`
                                : props?.appData?.logo
                          }
                          style={{ width: "100%", height: "100%", objectFit: "cover", borderRadius: "50%" }}
                        />
                      ) : (
                        <div style={{
                          width: "100%",
                          height: "100%",
                          borderRadius: "50%",
                          background: "#0a223d",
                          color: "#fff",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          fontWeight: 700
                        }}>
                          {props?.userType !== 8 &&
                            (props?.userType === 4 && props?.data?.is_company_user
                              ? (props?.data?.parent_company?.name || props?.applications?.company_name || props?.appData?.company_name || "Company")
                                ?.substring(0, 1)
                                ?.toUpperCase()
                              : (props?.applications?.company_name || props.appData?.company_name || "Company")
                                ?.substring(0, 1)
                                ?.toUpperCase()
                            )
                          }
                          {props?.userType == 8 && props.appData?.institution_name?.substring(0, 1)?.toUpperCase()}
                          {props?.userType == 20 && props.appData?.name?.substring(0, 1)?.toUpperCase()}
                          {props?.userType == 21 && "A"}
                          {props?.appData?.user_type == 24 && props.appData?.name?.substring(0, 1)?.toUpperCase()}
                        </div>
                      )}
                    </div>
                  </div>
                  <div>
                    {props?.userType !== 9 && props?.userType !== 10 && props?.userType !== 8 && (
                      <div style={{ fontWeight: 700, fontSize: 20 }}>
                        {capitalizeFirst(
                          props?.userType === 4 && props?.data?.is_company_user
                            ? props?.data?.parent_company?.name ||
                            props?.applications?.company_name ||
                            props?.appData?.company_name ||
                            "Company"
                            : props?.applications?.company_name ||
                            props.data?.company_name ||
                            props?.appData?.company_name ||
                            "Company",
                        )}
                      </div>
                    )}
                    {props?.userType == 9 && (
                      <div style={{ fontWeight: 700, fontSize: 20 }}>{props.appData?.first_name} {props.appData?.last_name}</div>
                    )}
                    {props?.userType == 10 && (
                      <div style={{ fontWeight: 700, fontSize: 20 }}>{props.appData?.first_name} {props.appData?.last_name}</div>
                    )}
                    {props?.userType == 8 && (
                      <div style={{ fontWeight: 700, fontSize: 20 }}>{props.appData?.institution_name}</div>
                    )}
                    {props?.userType == 20 && (
                      <div style={{ fontWeight: 700, fontSize: 20 }}>{props.appData?.name}</div>
                    )}
                    {props?.userType == 21 && (
                      <div style={{ fontWeight: 700, fontSize: 20 }}>Admin</div>
                    )}
                    {props?.data?.user_type == 24 && (
                      <div style={{ fontWeight: 700, fontSize: 20 }}>{props.data?.name}</div>
                    )}
                    <div style={{ display: "flex", gap: 8, marginTop: 6, flexWrap: "wrap" }}>
                      {applicationId && (
                        <span style={{
                          fontSize: 12,
                          background: "#f1f3f5",
                          border: "1px solid #e9ecef",
                          borderRadius: 6,
                          padding: "4px 8px"
                        }}>Application Ref: {applicationId}</span>
                      )}
                      {getStatusLabel() && (
                        <span style={{
                          fontSize: 12,
                          background: "#e7f5ff",
                          color: "#0b7285",
                          border: "1px solid #a5d8ff",
                          borderRadius: 6,
                          padding: "4px 8px"
                        }}>Status: {getStatusLabel()}</span>
                      )}
                    </div>
                    {showMyApplicationBtn && (
                      <button
                        className="dashuserprof"
                        style={{
                          whiteSpace: "nowrap",
                          background: "#0a223d",
                          color: "#fff",
                          border: "none",
                          borderRadius: 6,
                          padding: "4px 8px",
                          cursor: "pointer",
                          fontSize: 12
                        }}
                        onClick={(e) => props.handleMenus("profile")}
                      >
                        View My Profile
                      </button>
                    )}
                  </div>

                </div>


                {/* <div
                      className="dashuserprof"
                      onClick={(e) => handleMenuDash()}
                    >
                      <div>Visit Main Menu</div>
                    </div> */}

              </div>

            </div>

          </div>
          {props?.userType !== 30 &&
            <div className="col-12 col-md-6 dash-content-detail-items">
              <div className="kspa-response">
                <div className="message-from-kspace-btn">Opportunity to Advertise Your Product/Service on KSPACE Website</div>
                {/*
                {props.userType === 0 && (
                  <div className="message-from-kspace p-2">
                    {props.appData?.user_message &&
                      props.appData?.application_status === 5 ? (
                      <div className="">{props.appData?.user_message}</div>
                    ) : (
                      <div className="dash-app-dettail-no-msg">
                        No message from KSPACE
                      </div>
                    )}
                  </div>
                )}
                {props.userType !== 0 && (
                  <div className="message-from-kspace p-2">
                    {(props.appData?.user_message || props.appData?.superadmin_message) &&
                      (props.appData?.approval_status === 5 ||
                        props.appData?.project_status === 5 || props.appData?.status === 3 || props.appData?.status === 2) ? (
                      <div className="">{props.appData?.user_message ? props.appData?.user_message : props.appData?.superadmin_message ? props.appData?.superadmin_message : ""}</div>
                    ) : (
                      <div className="dash-app-dettail-no-msg">
                        No message from KSPACE
                      </div>
                    )}
                  </div>
                )}
                */}

                <div className="message-from-kspace p-2">
                  <div className="mb-2">Greetings from KSPACE!</div>
                  <div className="mb-2">
                    We are pleased to inform you that you can now promote your products or services on the KSPACE website. Your advertisement will be displayed prominently, providing excellent visibility among industry professionals and visitors.
                  </div>
                  <div className="mb-1" style={{ fontWeight: 600 }}>Advertisement Specifications:</div>
                  <ul className="mb-2">
                    <li>Format: JPG / JPEG / PNG</li>
                    <li>Size: 400px (width) × 250px (height)</li>
                  </ul>
                  <div className="mb-1" style={{ fontWeight: 600 }}>Tariff (Exclusive of GST):</div>
                  <ul className="mb-2">
                    <li>1 Month – ₹2,000</li>
                    <li>3 Months – ₹4,000</li>
                    <li>6 Months – ₹6,000</li>
                    <li>1 Year – ₹10,000</li>
                  </ul>
                  <div className="mb-2">
                    If you wish to advertise, please share your advertisement image in the specified format. Our team will include it on the website upon confirmation.
                  </div>
                  <div>
                    For any assistance, feel free to reach us at
                    {" "}
                    <a href="mailto:info@kspace.org.in">info@kspace.org.in</a>
                  </div>
                </div>
                {props.userType === 0 &&
                  props.appData?.application_status === 5 && (
                    <div className="message-from-kspace-action-cont">
                      {props?.appData?.to_user_reject_file_name && (
                        <div className="file-from-kspace">
                          <a
                            href={`${props.url}/${props.appData.to_user_reject_file_name}`}
                            target="_blank"
                          >
                            <CustomIcons
                              iconName="dashattachment"
                              iconClass="dash-attachment-icon"
                            />
                          </a>
                        </div>
                      )}
                      <div
                        className="update-current-propsosal blink"
                        onClick={(e) => {
                          props.updateProposal(props.userType);
                        }}
                      >
                        Update
                      </div>
                    </div>
                  )}
                {props.userType !== 0 && props.appData?.approval_status === 5 && (
                  <div className="message-from-kspace-action-cont">
                    {/* {props.status?.sample_file && (
                    <div className="file-from-kspace">
                      <a
                        href={`${props.url}/${props.status?.sample_file}`}
                        target="_blank"
                      >
                        <CustomIcons
                          iconName="dashattachment"
                          iconClass="dash-attachment-icon"
                        />
                      </a>
                    </div>
                  )} */}
                    <div
                      className="update-current-propsosal blink"
                      onClick={(e) => {
                        props.updateProposal(props.userType);
                      }}
                    >
                      Update
                    </div>
                  </div>
                )}
                {props.userType !== 0 && tokenData?.context_type !== "application" && tokenData?.user?.context_type !== "application" && !props?.data?.is_company_user && (
                  <div className="message-from-kspace-action-cont">
                    {/* {props.status?.sample_file && (
                    <div className="file-from-kspace">
                      <a
                        href={`${props.url}/${props.status?.sample_file}`}
                        target="_blank"
                      >
                        <CustomIcons
                          iconName="dashattachment"
                          iconClass="dash-attachment-icon"
                        />
                      </a>
                    </div>
                  )} */}
                    <div
                      className="update-current-propsosal blink"
                      onClick={(e) => {
                        props.updateProposal(props.userType);
                      }}
                    >
                      Update
                    </div>
                  </div>
                )}
                {props.userType !== 0 && props?.userType === 24 && props?.appData?.status === 7 && (
                  <div className="message-from-kspace-action-cont">

                    <div
                      className="update-current-propsosal blink"
                      onClick={(e) => {
                        props.updateProposal(props.userType);
                      }}
                    >
                      Update
                    </div>
                  </div>

                )}

                {props.userType !== 0 && (props?.userType === 20 && props.appData.status !== 9) && (
                  <div className="d-flex justify-content-between">
                    {/* {props.status?.sample_file && (
                    <div className="file-from-kspace">
                      <a
                        href={`${props.url}/${props.status?.sample_file}`}
                        target="_blank"
                      >
                        <CustomIcons
                          iconName="dashattachment"
                          iconClass="dash-attachment-icon"
                        />
                      </a>
                    </div>
                  )} */}
                    {(props.appData.status !== 7 && props.appData.status !== 9 && props.appData.status !== 8) &&
                      <div
                        className="update-current-propsosal blink"
                        onClick={(e) => {
                          props.updateProposal(props.userType);
                        }}
                      >
                        {props.userType !== 20 ?
                          "Update" : "Application Update"}
                      </div>}
                    {props.appData.status == 2 &&
                      <div
                        className="update-current-propsosal "
                        onClick={(e) => {
                          props.handleOpen(true);
                        }}
                      >
                        {props.userType == 20 && props.appData.status == 2 &&
                          "Deactivate"}
                      </div>}
                  </div>
                )}
              </div>
            </div>}
        </div>
      </div>
    </React.Fragment>
  );
}
